<template>
  <!-- :fill-height="!$vuetify.breakpoint.xsOnly" -->
   <v-container >
      <v-row class="mt-10" justify="center" v-bind:style="{ align:'center'}">
      <v-col  class="" align="center" cols="12" xl="12" lg="12" md="12" sm="12" xs="12" v-bind:style="{align:'center'}">
    <h1 class="" v-bind:style="{ color: '#000000',fontSize:'120px'}">
            {{ lg_page401.title }}
          </h1>
     </v-col>
    </v-row>

            <v-row class="mt-2" justify="center" v-bind:style="{align:'center' }">
            <v-col  class="" align="center" cols="12" xl="12" lg="12" md="12" sm="12" xs="12" v-bind:style="{align:'center'}">
          <h1 v-bind:style="{ color: '#000000',fontWeight:'600 !important',align:'center' }">
            {{ lg_page401.title_details }}
          </h1>
              </v-col>
           </v-row>

              <v-row class="mt-2" justify="center" v-bind:style="{align:'center' }">
            <v-col  class="" align="center" cols="12" xl="12" lg="12" md="12" sm="12" xs="12" v-bind:style="{align:'center'}">
          <h1 v-bind:style="{ color: '#000000',fontWeight:'300 !important',align:'center' }">
            {{ lg_page401.title_details2 }}
          </h1>
              </v-col>
           </v-row>

             <v-row class="mt-2" justify="center" v-bind:style="{align:'center' }">
            <v-col  class="" align="center" cols="12" xl="12" lg="12" md="12" sm="12" xs="12" v-bind:style="{align:'center'}">
              <v-btn
                @click="onClickMenu('/')"
                class="mb-1 white--text rounded-pill"
                width="300"
                height="40"
                v-bind:style="{ minWidth: 'auto', backgroundColor: '#04182D' }"
                outlined
              >
              {{ lg_page401.btn }}
              </v-btn>
                <v-btn
                @click="onClickMenu('/login-account')"
                class="mb-1 ml-2 black--text rounded-pill"
                width="300"
                height="40"
                v-bind:style="{ minWidth: 'auto', backgroundColor: '#ffffff',color:'#04182D' }"
                outlined
              >
              {{ lg_page401.btn_login }}
              </v-btn>
              </v-col>
           </v-row>
          
 
</v-container>
</template>

<script>
import api from "@/services/api";
import { server } from "../services/constants.js";
import { feature } from "../services/constants.js";
import { lg_page401 } from "./language/lg_page401.js";

export default {
  name: "Contact",
  data: () => ({
    showpop: false,
    dateNow: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
      .toISOString()
      .replace("T", " ")
      .substr(0, 16),
    margincardpriceplans: "mx-auto ml-0 mt-0 mr-0 mb-0",
    width: 420,
    width_emp: 600,
    text_fontsize: 30,
    privacy_sta: "false",
    privacyDlg: false,
          form: {
        name: "",
        firstname: "",
        lastname: "",
        email: "",
        phone: "",
        requestType: "",
        message: "",
        email_to: "contact@dcm.co.th",
      },
      valid: false,
      isRequirednameRules: true,
      isRequiredemailRules:true,
      isRequiredphoneRules:true,
      isRequiredmessageRules:true,
      nameRules:[],
      emailRules:[],
      phoneRules:[],
      messageRules:[],
  }),
   async beforeCreate() {
      this.$store.state.page_reload = false;


      localStorage.getItem(feature.LANGUAGE) === "th"
        ? this.lg_page401 = lg_page401.page401_th
        : this.lg_page401 = lg_page401.page401_en;


       
    },
    async mounted() {
            const userId = localStorage.getItem(server.USER_ID);
       if (userId && api.isLoggedIn()) {
      this.$router.push("/listroom");
      return;
    }
      var toggler = document.getElementsByClassName("caret");
const removeAllactiveclass = (indexnotremove)=> {
  for (var i = 0; i < toggler.length; i++) {
    if(i !== indexnotremove){
      document.querySelectorAll(".nested")[i].classList.remove("active");
      toggler[i].classList.remove("caret-down");
    }
}
}

const indexIn = (selector, element)=> {
  for (var i = 0; i < selector.length; ++i)
    if (toggler[i] === element) return i;
  return -1;
}

for (var i = 0; i < toggler.length; i++) {
  toggler[i].addEventListener("click", function() {
    removeAllactiveclass(parseInt(indexIn("." + this.classList[i], this)));

     if(!document.querySelectorAll(".nested")[parseInt(indexIn("." + this.classList[i], this))].classList.contains("active")){
      document.querySelectorAll(".nested")[parseInt(indexIn("." + this.classList[i], this))].classList.add("active");
    }else{
      document.querySelectorAll(".nested")[parseInt(indexIn("." + this.classList[i], this))].classList.remove("active");
    }

    if(toggler[parseInt(indexIn("." + this.classList[i], this))].classList.contains("caret-down")){
      toggler[parseInt(indexIn("." + this.classList[i], this))].classList.remove("caret-down");
    }else{
      toggler[parseInt(indexIn("." + this.classList[i], this))].classList.add("caret-down");
    }
  });
}

             this.nameRules = this.isRequirednameRules ? [v => !!v || `${this.lg_header_contract.rules_name}`]: [];
             this.emailRules = this.isRequiredemailRules ?[
        (v1) =>
          /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i.test(
            v1
          ) || this.lg_header_contract.rules_email,
      ]: [];
            this.phoneRules = this.isRequiredphoneRules ?[(v1) => /^\d{10}$/.test(v1) || this.lg_header_contract.rules_phone]: [];
            this.messageRules = this.isRequiredmessageRules ?[v => !!v || `${this.lg_header_contract.rules_message}`]: [];

    
    },
         watch: {
    isRequirednameRules(val) {
      if (val) {
        this.nameRules = [v => !!v || `${this.lg_header_contract.rules_name}`];
      } else {
        this.nameRules = [];
      }
    },
      isRequiredemailRules(val) {
      if (val) {
        this.emailRules = [
        (v1) =>
          /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i.test(
            v1
          ) || this.lg_header_contract.rules_email,
      ];
      } else {
        this.emailRules = [];
      }
    },
     isRequiredphoneRules(val) {
      if (val) {
        this.phoneRules = [(v1) => /^\d{10}$/.test(v1) || this.lg_header_contract.rules_phone];
      } else {
        this.phoneRules = [];
      }
    },
     isRequiredmessageRules(val) {
      if (val) {
        this.messageRules = [v => !!v || `${this.lg_header_contract.rules_message}`];
      } else {
        this.messageRules = [];
      }
    },
  },
    computed: {
  buttonsmall() {
     if(this.$vuetify.breakpoint.name === "xs"){
       return true;
     }
      },
    widthbutton() {
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          return "75%";
        case "sm":
          return "76%";
        case "md":
          return "60%";
        case "lg":
          return "40%";
        case "xl":
          return "40%";
      }
    },
    widthheightimage(){
 switch (this.$vuetify.breakpoint.name) {
        case "xs":
          return "300";
        case "sm":
          return "400";
        case "md":
          return "400";
        case "lg":
          return "400";
        case "xl":
          return "400";
      }
      },
    },
    methods: {
      onClickMenu(link) {
      // console.log(link);
      this.$router.push(link).catch((err) => {});
    },
    async sendEmail(e) {
     
       
        if (this.$refs.form.validate()) {
           this.$swal.showLoading();
           console.log(this.form);
        // return;
      try {
        // this.form.name =  `${this.form.firstname} ${this.form.lastname}`;
        this.$swal.showLoading();
        const response = await api.onUserSendRequestContact(this.form);
        this.$swal.close();
        if (response && response.data && response.data.status === "success") {
          this.$swal.fire("Success", response.data.message, "success");
          // Reset form field
          this.form.name = "";
          this.form.firstname = "";
          this.form.lastname = "";
          this.form.email = "";
          this.form.phone = "";
          this.form.requestType = "";
          this.form.message = "";
        } else {
          this.$swal.fire("Error", response.data.message, "error");
        }
      } catch (error) {
        console.log({ error });
        this.$swal.close();
        this.$swal.fire("Error", error.message, "error");
      }
    }
    },
    },
};
</script>


<style scoped>
/*
@media only screen and (max-width: 600px) {
  .v-card{
    margin-top:40px;
     margin-bottom:40px;
      margin-right:40px;
       margin-left:40px;
}
}
*/
@media only screen and (max-width: 320px)  {
  .v-application {
    margin-top:-50px;
  }
  /* .homemain{
    height:80vh !important;
  }
  .homefeature{
    height:150vh !important;
  }
  .homepricing{
    height:90vh !important;
  }
  .homegettotouch{
    height:100vh !important;
  } */
}
  @media only screen and (min-width: 320px) and (max-width: 599px)  {
  /* .mainpage-container {
    margin-top:-150px;
  } */
  .v-application {
    margin-top:-50px;
    /* height: 110% !important; */
  }
  /* .homemain{
    height:75vh !important;
  }
  .homefeature{
    height:130vh !important;
  }
  .homepricing{
    height:70vh !important;
  }
  .homegettotouch{
    height:90vh !important;
  } */
}

/* @media (max-width: 959px) {
  .homefeature{
    height: 40% !important;
  }
} */

@media only screen and (min-width: 600px) and (max-width: 960px)  {
  .homefeature{
    height:80vh !important;
  }
}

@media (min-width: 960px) {
  .mainpage-container {
    margin-top: 3rem
  }
}

</style>
